import * as types from "./jenisLembaga.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { JenisLembaga } from "../../interfaces/JenisLembaga";
import { JenisLembagaCreateResponse, JenisLembagaDetailResponse, JenisLembagaListResponse, JenisLembagaUpdateResponse } from "./types";

export const selectJenisLembaga = (jenisLembaga: JenisLembaga | null) => action(types.SELECT_JENIS_LEMBAGA, { jenisLembaga });

export const updateName = (name: string) => action(types.UPDATE_NAME, { name });

export const updateStatus = (status: number) => action(types.UPDATE_STATUS, { status });

export const initializeCreateJenisLembaga = () => {
  const jenisLembaga: JenisLembaga | null = {
    ID: -1,
    CO_TYP_NAME: '',
    STATUS: 0
  }

  return action(types.INITIALIZE_CREATE_JENIS_LEMBAGA, { jenisLembaga })
}

export const getDetailJenisLembagaAsync = createAsyncAction(
  types.GET_DETAIL_JENIS_LEMBAGA_REQUEST,
  types.GET_DETAIL_JENIS_LEMBAGA_SUCCESS,
  types.GET_DETAIL_JENIS_LEMBAGA_FAILURE
)<{ id: number }, JenisLembagaDetailResponse, ErrorResponse>();

export const getJenisLembagaAsync = createAsyncAction(
  types.GET_JENIS_LEMBAGA_REQUEST,
  types.GET_JENIS_LEMBAGA_SUCCESS,
  types.GET_JENIS_LEMBAGA_FAILURE
)<undefined, JenisLembagaListResponse, ErrorResponse>();

export const updateJenisLembagaAsync = createAsyncAction(
  types.UPDATE_JENIS_LEMBAGA_REQUEST,
  types.UPDATE_JENIS_LEMBAGA_SUCCESS,
  types.UPDATE_JENIS_LEMBAGA_FAILURE
)<JenisLembaga, JenisLembagaUpdateResponse, ErrorResponse>();

export const createJenisLembagaAsync = createAsyncAction(
  types.CREATE_JENIS_LEMBAGA_REQUEST,
  types.CREATE_JENIS_LEMBAGA_SUCCESS,
  types.CREATE_JENIS_LEMBAGA_FAILURE
)<JenisLembaga, JenisLembagaCreateResponse, ErrorResponse>();
